import React from "react";
import { FormattedHTMLMessage, injectIntl } from "react-intl";
import {
  FormSelectChoice,
  FormFieldComponentProps,
  VerificationServiceProps,
  Organization,
} from "../../../lib/types/types";
import { FieldLabel } from "../../FieldLabel";
import { InputSelectComponent } from "../../FormInputs/InputSelect/InputSelectComponent";
import { SortByLabel } from "../../../lib/utils/structures/FormSelectChoice";
import { orgToOption } from "../../../lib/utils/stepComponentHelpers/stepComponentHelpers";

export const LowIncomeOrganization = ({
  value,
  isErrored,
  onChange,
  verificationService,
  intl,
  placeholder = "",
  isRequired = false,
}: FormFieldComponentProps & VerificationServiceProps) => {
  const { viewModel, orgList } = verificationService;
  const { countryChoice } = viewModel;
  let options: FormSelectChoice[] = [];
  const inputId = "sid-low-income";

  if (orgList) {
    let newOrganizations: Organization[] = orgList;

    if (countryChoice) {
      newOrganizations = orgList.filter((org) => org.country === countryChoice.value);
    }
    options = newOrganizations.map(orgToOption);
  }

  const handleStateChange = (selectedOrgOption: FormSelectChoice, onChange: Function) => {
    if (selectedOrgOption) {
      onChange({
        id: selectedOrgOption.value,
        name: selectedOrgOption.label,
      });
    } else {
      onChange({
        id: 0,
        name: "",
      });
    }
  };

  return (
    <div className="sid-field sid-low-income-id">
      <div className="sid-l-space-top-md" />
      <FieldLabel
        text={
          <FormattedHTMLMessage
            id="lowIncomeOrganization"
            defaultMessage="Government Assistance Program"
          />
        }
        htmlForLabel="sid-low-income"
        id="sid-low-income-label"
        displayClasses={placeholder && "sid-h-screen-reader-only"}
        isRequired={isRequired}
      />

      <InputSelectComponent
        fieldId="organization"
        inputId={inputId}
        fieldLabelId={`${inputId}-label`}
        isErrored={isErrored}
        options={SortByLabel(options)}
        onChange={(organization: FormSelectChoice) => handleStateChange(organization, onChange)}
        value={options.find((option) => option.value === (value && value.value))}
        placeholder={
          placeholder ||
          intl.formatHTMLMessage({
            id: "lowIncomeOrganizationPlaceholder",
            defaultMessage: "Government Assistance Program",
          })
        }
        isRequired={isRequired}
      />
      {isErrored ? (
        <div className="sid-field-error">
          <FormattedHTMLMessage
            id="errorId.invalidOrganization"
            defaultMessage="You must select an organization from the list"
          />
        </div>
      ) : null}
    </div>
  );
};

export const LowIncomeOrganizationComponent = injectIntl(LowIncomeOrganization);
